import { Popup, SemanticICONS, SemanticSIZES } from 'semantic-ui-react';
import { Icon, Label } from '@britishcouncil/react-admin';

import { CertificationStatus } from 'api';
import { formatDate } from 'utils';
import { getStatusColor, getStatusText } from './examinerStatusesHelper';

type ExaminerStatusLabelProps = {
  text?: string;
  status?: CertificationStatus;
  nextCertificationDate?: string | null;
  iconName?: SemanticICONS; //icon for speaking/writing
  label?: string; //A1, A2, B1
  template?: 'label' | 'shortLabel';
  size?: SemanticSIZES;
  showTooltip?: boolean;
};

export const ExaminerStatusLabel = ({
  text,
  status,
  nextCertificationDate,
  iconName,
  label,
  template = 'shortLabel',
  size = 'medium',
  showTooltip = true,
}: ExaminerStatusLabelProps) => {
  const statusText = getStatusText(status, nextCertificationDate);
  const color = getStatusColor(status, nextCertificationDate);

  if (template === 'label') {
    return (
      <Label
        basic
        color={color}
        icon={iconName}
        size={size}
        content={
          <>
            {(text ?? '') + statusText}{' '}
            {nextCertificationDate && (
              <Popup
                content="Next certification date"
                position="top center"
                trigger={<span>({formatDate(nextCertificationDate)})</span>}
              />
            )}
          </>
        }
      />
    );
  }

  const popupContent = (text ?? '') + statusText;

  const shortLabel = (
    <Label size="small" color={color}>
      {label && <b>{label}</b>}
      {iconName && <Icon fitted={true} name={iconName} />}
    </Label>
  );

  if (!showTooltip) {
    return shortLabel;
  }

  return (
    <Popup
      disabled={!popupContent}
      content={popupContent}
      position="top center"
      trigger={shortLabel}
    />
  );
};
